import React from "react";
import { MapPin, Home, ShieldCheck, Leaf, Building2 } from "lucide-react";

const locations = [
  {
    title: "BMRDA Approved Plots in Chikka Madure",
    description: "A rapidly growing residential hub with direct access to Tumkur Road and surrounded by emerging infrastructure projects.",
    icon: <MapPin className="w-6 h-6 text-[#1B0727]" />
  },
  {
    title: "Gated Community Plots near Nelamangala",
    description: "Ideal for families and investors, these plots offer a secure, well-planned environment with great connectivity to Bangalore city.",
    icon: <Home className="w-6 h-6 text-[#1B0727]" />
  },
  {
    title: "Sites near Tumkur Road, Doddaballapura Road, and STRR",
    description: "Located in key satellite town zones, these plots are strategically positioned for future urban expansion and high appreciation.",
    icon: <Building2 className="w-6 h-6 text-[#1B0727]" />
  },
  {
    title: "Farm Villa Projects near Bangalore",
    description: "Our premium farm villa developments combine organic living with luxury, offering a peaceful retreat within driving distance from the city.",
    icon: <Leaf className="w-6 h-6 text-[#1B0727]" />
  },
  {
    title: "Weekend Villa Plots and Organic Farm Lands",
    description: "Perfect for eco-conscious buyers looking to invest in nature-rich surroundings that support wellness and recreational living.",
    icon: <ShieldCheck className="w-6 h-6 text-[#1B0727]" />
  },
   {
    title: "",
    description: "Each of these micro-markets is supported by strong infrastructure initiatives, proximity to upcoming highways, and increasing demand for residential and weekend homes—making them prime choices for both homebuyers and investors.",
    icon: <ShieldCheck className="w-6 h-6 text-[#1B0727]" />
  }
];

export default function CoreLocations() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:mt-5 md:py-12">
      <h3 className="text-2xl md:text-3xl font-bold md:text-center mb-4 text-[#1B0727]">Our Core Locations</h3>
      <p className="md:text-center text-gray-600 mb-10 max-w-2xl mx-auto">
        At Urban Nest Properties, we strategically focus on high-growth real estate corridors that offer exceptional long-term value, legal clarity, and superior infrastructure. Each of our locations is carefully selected to ensure high ROI, seamless connectivity, and a premium lifestyle experience.
      </p>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {locations.map((location, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-md p-6 flex flex-col items-start hover:shadow-2xl transition duration-300"
          >
            <div className="bg-green-100 p-3 rounded-full mb-4">
              {location.icon}
            </div>
            <h3 className="font-semibold text-lg mb-2 text-gray-800">{location.title}</h3>
            <p className="text-gray-600 text-sm">{location.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
